const ForbiddenPage = () => {
    return <h1>403 - Forbidden: You do not have access to this page.</h1>;
  };
  
export default ForbiddenPage;
  